import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getFirstName(name: string) {
  return name.split(" ")[0];
}

export function resolveStoryImage(image_versions2: any) {
  return image_versions2?.candidates?.[0].url || null;
}
